module.exports = __webpack_public_path__ + "img/bg2.ec5d7d48.png";